"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.capitalizeFirstLetter = void 0;
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == _typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw new Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator["return"] && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(_typeof(e) + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw new Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, "catch": function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw new Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }
function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }
var Papa = require("papaparse");

/**
 * This is the primary function all numbers for display should be passed through
 * @param number
 * @param decimalPlaces
 * @param includeDollarSign
 * @returns {string|*}
 */
function formatNumber(number) {
  var decimalPlaces = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 2;
  var includeDollarSign = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
  if (isNaN(number)) {
    throw new Error('You must provide a number to formatNumber.');
  }
  return "".concat(includeDollarSign ? '$' : '').concat(Number(number).toFixed(decimalPlaces).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ','));
}

// TODO: remove this once everything is using formatNumber
/**
 * @param number
 * @returns {string|*}
 */
function numberWithCommas(number) {
  if (!number && number !== 0) {
    return number;
  }
  return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
}

// TODO: remove this once everything is using formatNumber
/**
 * @param num
 * @param decimalPlaces
 * @private
 */
function numberWithCommasDecimals(num) {
  var decimalPlaces = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 2;
  if (isNaN(num)) {
    return num;
  }
  return Number(num).toFixed(decimalPlaces).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
}

/**
 * @param x
 * @private
 */
function parsePhoneNumber(x) {
  return x.replace(/\D+/g, '').replace(/(\d{3})(\d{3})(\d{4})/, '($1) $2-$3');
}

/**
 *
 * @returns
 */
var parseFile = function parseFile() {
  return new Promise(function (resolve) {
    Papa.parse("https://docs.google.com/spreadsheets/d/e/2PACX-1vTi0L6yH9Hb6eC7re-W3c3PlAFTzH0ktkmXE22iuVpyK6wvAMftYNRS0OR3W1Nuy9-_fWx5nHPtCir_/pub?output=csv", {
      download: true,
      header: true,
      complete: function complete(results) {
        resolve(results.data);
      }
    });
  });
};

/**
 *
 */
function fetchTelusDrugIDs() {
  return _fetchTelusDrugIDs.apply(this, arguments);
}
/**
 *
 * @param {*} string
 */
function _fetchTelusDrugIDs() {
  _fetchTelusDrugIDs = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
    var parsedData;
    return _regeneratorRuntime().wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          _context.next = 2;
          return parseFile();
        case 2:
          parsedData = _context.sent;
          return _context.abrupt("return", parsedData);
        case 4:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
  return _fetchTelusDrugIDs.apply(this, arguments);
}
function snakeCapitalCase(string) {
  return string.replace(/\W+/g, " ").split(/ |\B(?=[A-Z])/).map(function (word) {
    return word.toLowerCase().charAt(0).toUpperCase() + word.slice(1);
  }).join('_');
}

/**
 *
 * @param {*} token
 * @param {*} index
 */
function concatTokens(token, index) {
  if (index === undefined || null) {
    index = 1;
  }
  var a = token.toString() + index.toString();
  a = a.toLowerCase().replace(/[. ,:-]+/g, "-");
  return a;
}

/**
 * @param coverage
 * @param invoice
 * @returns {number}
 * @private
 */
var calculateActiveUsers = function calculateActiveUsers(coverage, invoice) {
  var activeUsers = 0;
  Object.keys(invoice.currentTransactions.users).map(function (user) {
    if (invoice.currentTransactions.users[user].amounts[coverage].premium > 0) {
      activeUsers += 1;
    }
    return true;
  });
  return activeUsers;
};

/**
 *
 * @param {*} obj
 * @returns array of keys
 */
var sortObjByTitle = function sortObjByTitle(obj) {
  return Object.keys(obj).sort(function (a, b) {
    // Compare the division names without spaces and all lowercase
    var aTitle = obj[a].title.toLowerCase().replace(/ /g, '');
    var bTitle = obj[b].title.toLowerCase().replace(/ /g, '');

    /*
     * First compare without numbers to see if the strings match. If they do match then sort by number
     * If the strings without numbers aren't the same then sort alphabetically
     */
    return aTitle.replace(/[0-9]/g, '') === bTitle.replace(/[0-9]/g, '') && Number(aTitle.replace(/^\D+/g, '')) - Number(bTitle.replace(/^\D+/g, '')) || aTitle.localeCompare(bTitle);
  });
};

/**
 * @param {*} string
 * @returns
 */
var camelToNormalCase = function camelToNormalCase(item) {
  return (/* This series of functions takes converts the camelCase string to Normal Case */
    item.replace(/([A-Z])/g, ' $1').replace(/^./, function (str) {
      return str.toUpperCase();
    })
  );
};

/**
 * Capitalizes the first letter of a word.
 * @param {string} word - The word to be capitalized.
 * @returns {string} - The word with the first letter capitalized.
 */
var capitalizeFirstLetter = exports.capitalizeFirstLetter = function capitalizeFirstLetter(word) {
  if (!word) {
    return null;
  }
  return word.charAt(0).toUpperCase() + word.slice(1);
};

/**
 * 
 * @param {*} str 
 * @returns 
 */
var cleanFilename = function cleanFilename(str) {
  // Remove accents and normalize the string
  str = str.normalize('NFD').replace(/[\u0300-\u036f]/g, '');

  // Replace œ with oe
  str = str.replace(/œ/g, 'oe');

  // Replace spaces and other characters with hyphen
  str = str.replace(/[/\\?%*:|"<> ]/g, '-');

  // Replaces multiple hyphens with one hyphen
  str = str.replace(/--+/g, '-');

  // Remove extra hyphens from beginning or end of the string
  str = str.replace(/(^-+|-+$)/g, '');

  // Remove square brackets and single quotes
  str = str.replace(/[[\]']/g, '');

  // Convert to lowercase
  str = str.toLowerCase();
  return str;
};
var _default = exports["default"] = {
  formatNumber: formatNumber,
  numberWithCommas: numberWithCommas,
  numberWithCommasDecimals: numberWithCommasDecimals,
  parsePhoneNumber: parsePhoneNumber,
  fetchTelusDrugIDs: fetchTelusDrugIDs,
  snakeCapitalCase: snakeCapitalCase,
  concatTokens: concatTokens,
  calculateActiveUsers: calculateActiveUsers,
  sortObjByTitle: sortObjByTitle,
  camelToNormalCase: camelToNormalCase,
  capitalizeFirstLetter: capitalizeFirstLetter,
  cleanFilename: cleanFilename
};